import { restRequest as o, REST_VERBS as r, FETCH_MODE as u } from "@ado/base-service";
import { createRequestOptionsBuilder as s } from "../../../shared/libraries/request_options_building/index.js";
import { KnownQueryKey as n } from "../../../shared/libraries/known_query_parameters/index3.js";
const c = "/api/foundation/search", p = "https://algolia-windows-function-appruquidev.azurewebsites.net/api/algolia-search/v1/products/";
function E(t) {
  const e = s().setKnownQueryParameters(n.Host).setAdditionalQueryParameters({ countryCode: t }).build();
  return o(r.GET, `${c}/v1/contracts`, e);
}
function f(t, e = p, a = "US") {
  const i = s().setKnownQueryParameters(n.Host).setMode(u.CORS).setAdditionalQueryParameters({ query: t, countryCode: a }).build();
  return o(r.GET, e, i);
}
export {
  f as getAlgoliaSearchContracts,
  E as getContracts
};
//# sourceMappingURL=index.js.map
